/* Cash Transactions Client barrel export */

import { CashTransactionClientMocked } from './cashTransactionClientMocked';

// Re-export types
export * from './cashTransactionTypes';

// Cash Transactions has no real backend yet — always use the in-code mocked client.
const cashTransactionClient = new CashTransactionClientMocked();

/** @deprecated Use cashTransactionClient directly */
export const getCashTransactionClient = () => cashTransactionClient;

export { cashTransactionClient };
export type { ICashTransactionClient } from './ICashTransactionClient';
